<template>
	<div class="row">
		<div class="col-12">
			<div class="accordion" role="tablist">
				<b-card no-body class="noteSearchPanel mb-0">
					<b-card-header
						header-tag="header"
						class="p-0"
						role="tab">
						<b-button
							block						
							class="collapseBTN text-truncate"
							v-on:click="Accordion1Click"
							><b-icon
								icon="arrow-down-right-circle"
								aria-hidden="true"
							></b-icon>
							<MdTitleRegInfo
								v-bind:RegistrationInfo="RegistrationInfo" 
								v-bind:titlePrefix="$t('ClinicalNotes.CLINICALNOTES')" 
								v-bind:IsClinical="true"
								v-bind:titleRef="'titleElementClinicalNotes'"
								v-bind:patientCode="this.$route.params.id"
								v-bind:propClass="''"
								v-bind:propTag="'span'"
								v-bind:isTitle=false>
							</MdTitleRegInfo>
						</b-button>
					</b-card-header>
					<b-collapse
						id="accordion-1"
						visible
						accordion="ClinicalNotes"
						:class="this.ClassAccordion1"
						role="tabpanel"
						v-show="ShowFilter && !ShowNote"
						>
						<b-card-body class="p-1">
							<b-card-text class="notesPanelsClinical cutescroll">
								<b-row>
									<b-col md="4" lg="4" sm="12">
										<!--<MdEdit 
											v-bind:Label="$t('Shared.datefrom')"
											v-bind:TypeProp="'date'" 
											v-bind:Name="'DateFrom'"
											v-model="DateFrom"
											v-bind:Min="'1900-01-01'"
											v-bind:Max="'2200-12-31'"
											v-on:change="DateFromChange($event)"
											v-bind:Id="'input_date_from'"
											v-bind:OnPressEnter="SearchNotes">                                     
										</MdEdit>-->
										<MdDateTime 
                                            :Label="$t('Shared.datefrom')" 
                                            :Model="DateFrom"                           
                                            @input="DateFrom = $event"                            
                                            :Id="'ClinicalNotesDateFrom'"
                                            :Type="'date'"
                                            :Change="DateFromChange"
                                            :isRequired="true"                           
                                            :isConfirm="false"
                                            :ReadOnly="false">
                                        </MdDateTime>
									</b-col>
									<b-col md="4" lg="4" sm="12">
										<!--<MdEdit 
											v-bind:Label="$t('Shared.dateTo')"
											v-bind:TypeProp="'date'" 
											v-bind:Name="'DateTo'"
											v-model="DateTo"
											v-bind:Min="'1900-01-01'"
											v-bind:Max="'2200-12-31'"
											v-on:change="DateToChange($event)"
											v-bind:Id="'input_date_to'"
											v-bind:OnPressEnter="SearchNotes">                                     
										</MdEdit>-->
										<MdDateTime 
                                            :Label="$t('Shared.dateTo')" 
                                            :Model="DateTo"                           
                                            @input="DateTo = $event"                            
                                            :Id="'ClinicalNotesDateTo'"
                                            :Type="'date'"
                                            :Change="DateToChange"
                                            :isRequired="true"                           
                                            :isConfirm="false"
                                            :ReadOnly="false">
                                        </MdDateTime>

									</b-col>
									<b-col md="4" lg="4" sm="12">													
											<div class="form-group">
												<MdSelect
												v-bind:Label="this.LabelTherapies"
												v-bind:Options="OptionTherapies"
												v-bind:Model="this.TherapiesVModel"
												v-bind:Placeholder="selectPlaceholder"																
												v-bind:FieldDescription="'name'"
												v-bind:Multiple="false"
												v-bind:isRequired="true" 
												v-bind:isValid="isValidCategories"
												v-bind:FieldCode="'code'"
												:Input="ChangeDropDownTherapies"
												v-bind:Name="'therapies_select'"
												id="therapies_select"/>
											</div>												
									</b-col>											
								</b-row>
								<b-row>
									<b-col md="4" lg="4" sm="12">
										<div class="form-group">
												<MdSelect
												v-bind:Label="$t('ClinicalNotes.NoteTypes')"
												v-bind:FieldDescription="'description'"
												v-bind:FieldCode="'notesid'"
												v-bind:Options="OptionNoteTypes"
												v-bind:Model="this.NoteTypesVModel"
												v-bind:Placeholder="selectPlaceholder"
												v-bind:Multiple="true"
												:Input="ChangeDropDownNoteTypes"
												v-bind:Name="'note_types_select'"
												id="note_types_select"/>
											</div>		
									</b-col>											
									<b-col md="4" lg="4" sm="12">													
											<div class="form-group">
												<MdSelect
												v-bind:Label="$t('ClinicalNotes.NoteStatus')"
												v-bind:Options="OptionNoteStatus"
												v-bind:ModelArray="this.NoteStatusVModel"
												v-bind:Placeholder="selectPlaceholder"																
												v-bind:FieldDescription="'name'"
												v-bind:Multiple="false"
												v-bind:FieldCode="'value'"
												v-bind:IfUsevalidation="false"
												:Input="ChangeDropDownNoteStatus"
												v-bind:Name="'note_status_select'"
												id="note_status_select"/>
											</div>										
									</b-col>		
									<b-col md="4" lg="4" sm="12">
										<div class="text-center text-md-right mt-3">
											<button 
												v-on:click="SearchNotes"
												type="button"
												class="btn btn-primary btn-login mx-2 pull-right"												
												id="btnsearchinput">
												{{ $t('Shared.Search') }}
											</button>
										</div>
									</b-col>
								</b-row>
								<b-row>
									<b-col sm="12" lg="12" md="12">
										<MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
										<MdTable
											v-bind:fields="fields"
											v-bind:items="items"
											v-bind:totalRows="totalRows"
											v-bind:useAddTime="true"
											v-bind:totalRowsSubItems="totalRowsSubItems"
											v-bind:showMessageIsEmpty="
												ShowMessageIsEmpty
											"
											v-bind:isReadOnly="false"
											v-bind:selectMode="
												selectMode
											"
											v-bind:currentPage="
												currentPage
											"
											v-bind:currentPageSubItems="currentPageSubItems"
											v-bind:perPage="perPage"
											v-bind:perPageSubItems="perPageSubItems"
											v-bind:pageOptions="
												pageOptions
											"
											v-bind:pageOptionsSubItems="
												pageOptionsSubItems
											"
											v-bind:refTable="refTable"
											
											:onRowSelected="
												onRowSelected
											"
											:onFiltered="onFiltered"
											:pageChanged="pageChanged"
											:pageChangedSubItems="pageChangedSubItems"
											v-bind:ShowDetails="true"
											:perPageFunction="
												PerPageFunction
											"
											:perPageFunctionSubItems="
												PerPageFunctionSubItems
											"
											:avisar="onResultados"
											:CheckClick="onCheck"
											:NotePatientInfo="PatientInfo"
										>
										</MdTable>
									</b-col>
								</b-row>
							</b-card-text>
						</b-card-body>
					</b-collapse>
				</b-card>

				<b-card no-body class="openNotesPanel mb-0">
					<b-card-header
						header-tag="header"
						class="p-0"
						role="tab">
						<b-button
							v-if="ClinicalNotesListOpened.length > 0"
							block							
							class="collapseBTN"
							v-on:click="ClickBtnAccordion2"
							><b-icon
								icon="arrow-down-right-circle"
								aria-hidden="true"
							></b-icon>
							{{ $t('ClinicalNotes.OPENNOTES') }}</b-button>
					</b-card-header>
					<b-collapse
						id="accordion-2"
						accordion="ClinicalNotes"
						role="tabpanel"
						:class="this.ClassAccordion2"
						v-show="ShowNote && !ShowFilter"
						ref="a2">
						<b-card-body class="p-1">
							<b-card-text class="notesPanels">
								<!-- OPEN NOTES CODE -->
								<div :class="this.ClassContainerNotes" ref="ContainerNotes">
								<MdNote
									v-for="(model, index) in this.ClinicalNotesListOpened"
									v-bind:NOTE="model.description"										
									v-bind:TransDate="model.date"
									v-bind:Time="model.Time"
									v-bind:EventScheduler="false"
									v-bind:Location="'ClinicalNotes'"
									v-bind:Header="model"
									v-bind:IsChartReview="false"
									v-bind:IsClinicalNote="true"
									v-bind:ProgramCode="ProgramCode"
									v-bind:CategoryCode="TherapiesVModel"									
									:key="model.Id"
									:id="model.Id"
									v-on:remove="CloseNote(index)"
									:model="model"
									v-bind:NotePatientInfo="PatientInfo"
									:aiAssistContext="model.aiAssistContext">
								</MdNote>
								</div>
								<!-- END OPEN NOTES CODE -->
							</b-card-text>
						</b-card-body>
					</b-collapse>
				</b-card>
			</div>
		</div>
	</div>
</template>

<script>
import EnumService from "@/services/enum.service";
import moment from "moment";
import DBFunctions from '@/common/DBFunctions.js'
import LocalStorage from '@/services/storage.service'
import GlobalService from '@/services/global.service'
import ClinicalService from '@/services/clinical.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import Utils from "@/common/utils";
import { EventBus } from '@/event-bus.js';
import Permission from '@/common/Permission'

export default {

    /*beforeRouteEnter(to, from, next) {
        next(async vm => {
            const iCN = await vm.$store.state.isUseClinicalNotes;
            if(iCN) next()
            else next('/accessdenied');
        }) 
	},*/
	
	beforeRouteLeave(to, from, next) {
	if (this.$store.state.unauthorized) {
		return next();
	}
	if (this.pendingChanges()) {
		this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
          title: this.$t('ClinicalNotes.ClinicalNotes'),
          okTitle: this.$t('Shared.BtnSave'),
          cancelTitle: this.$t('Shared.BtnDismiss'),
          footerClass: 'p-2',
          titleClass: 'modal-title modal-type-warning'
        })
          .then(value => {
            if(!value){
              next();
            } else {
				next(false);
				EventBus.$emit('saveFromClinicalNotes', to);
              //return;
            }
          })		
	} else {
		next()
	}
    },
	mixins: [DBFunctions,ShowMessage,Permission],
	name: "ClinicalNotes",
	data() {
		return {
			NoteOptions:{},
			PatientInfo:{},
			//permission:[],
			isValidCategories:true,
			//Menu : this.$store.state.leftMenu,
			ClinicalNotesListOpened:[],
			ProgramCode:'',
			LabelTherapies:'',
			EmployeeCode:'',			
			OptionTherapies: [],
			TherapiesVModel: "",
			OptionNoteTypes: [],
			NoteTypesVModel: "",
			OptionNoteStatus: EnumService.NoteStatus,
			NoteStatusVModel: {value:0,name: this.$t('Shared.All')},
			selectPlaceholder: this.$t('ClinicalNotes.SelectOptions'),			
			ClassContainerNotes:'',
			ClassAccordion1:'',
			ClassAccordion2:'',
            ShowNote:false,
			ShowFilter:true,
			ExistsNote:false,
			Note1:{
				Visible:false,
				Visited:false
			},
			pageOptions: [5, 10, 15],
			pageOptionsSubItems: [5, 10, 15],
			totalRows: 0,
			totalRowsSubItems: 0,
			currentPage: 1,
			currentPageSubItems: 1,
			perPage: 10,
			perPageSubItems: 5,
			filter: null,
			filterOn: [],
			NotesId:'',
			items: [],
			selectMode: "single",
			selected: [],
			Header: {},			
			refTable: "selectableTable",
			CountNotesOpened:0,
			DateFrom: moment(this.NewDate).format("YYYY-MM-DD"),
			DateTo: moment(this.NewDate).format("YYYY-MM-DD"),
			dateArr: [],
			NoteDates:[],
			RegistrationInfo:{},
			parameter:{
				NoteTypes:[],
				NoteStatus:0
			},
			OptionsRightMenu:{
			visible:true,
			ItemsList:[],
			btnvisible:true,
			itemdisabled: false,		
			PatientCode:''			
		},
			ShowMessageIsEmpty: false,
			fields: [
				{ key: 'show_details', label: this.$t('ClinicalNotes.ShowDetails'), sortable: true},
				{ key: 'description', label: this.$t('Shared.Description'), sortable: true},
				{ key: 'frequency', label: this.$t('Shared.Frequency'), sortable: true},
				{ key:'notesId', sortable: true, class:'hidden'},			
				{ key: 'isGroup', label: this.$t('ClinicalNotes.IsGroup'), sortable: true, formatter: value => {return value ? 'Y' : 'N'}},				//{key:'HeaderId',sortable: true, class:'hidden'},
			],
		};
	},

	methods: {

	async getPatientInfo(){
		this.PatientInfo = await this.getData(this.$route.params.id);
	},
	async getProgramCodeByRecordId(){
		this.RegistrationInfo = await this.getRegistrationInfoTitle(this.$route.params.recordid);
		const { dob, dateFrom, dateTo, age, programCode } = this.RegistrationInfo; // Destructure for easier access

		if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
		if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);	
		if (dob) this.RegistrationInfo.dob =  Utils.formatterDateToString(dob);
		if (age) this.RegistrationInfo.age = age === 0 ? "0" : age;
		if (programCode) this.ProgramCode = this.RegistrationInfo.programCode;
		
		this.getNotesTherapies();
	},

	async getNoteOption(){
		this.NoteOptions = await this.getNoteOptions();   
		this.LabelTherapies = this.NoteOptions.useCategory?this.$t('ClinicalNotes.CATEGORIES'):this.$t('ClinicalNotes.THERAPIES');
    },


	ChangeDropDownNoteStatus(NoteStatus){	
		if(NoteStatus !== null){
			this.NoteStatusVModel =  NoteStatus;
		}else{
			this.NoteStatusVModel.value =  0;
		}
		
	},

	validate_required(){
		this.isValidCategories = this.TherapiesVModel && this.TherapiesVModel.length > 0 ? true : false;   
		return this.isValidCategories; 
	},

	ChangeDropDownNoteTypes(types){
     var l = types.length;
     var NoteTypes = [];
     if(l>0){
       var i = 0;
        types.forEach(function(e) {   
        if(i<l-1){
          NoteTypes += e.notesid+",";
        }else{
          NoteTypes += e.notesid;
        }
        i++;                    
        });
        this.parameter.NoteTypes = NoteTypes;
    }else{
      this.parameter.NoteTypes = [];
    }    
    },

	DateFromChange(){	
		setTimeout(() => this.getNotesTherapies(), 50);
	},



	DateToChange(){	
		setTimeout(() => this.getNotesTherapies(), 50);	
	},

	getNoteTypes(){
		GlobalService.getNoteTypes(true,this.TherapiesVModel)
            .then((response) => {
              if(response.data && response.data.length > 0){
                this.OptionNoteTypes = response.data;				
              }             
            })
            .catch((error) => {             
             this.showResponseErrorMessage(error);
            });
	},


	getNotesTherapies(){		
		var param = {
			DateFrom:this.DateFrom,
			DateTo:this.DateTo,
			ProgramCode:this.ProgramCode,
			EmployeeCode:this.EmployeeCode,
			RecordId: this.$route.params.recordid
		};			
		var ValidDateFrom =  Utils.IsValidFieldDate(param.DateFrom);
		var ValidDateTo =  Utils.IsValidFieldDate(param.DateTo);
		this.OptionTherapies = [];
		if(ValidDateFrom && ValidDateTo){	
			GlobalService.getNotesTherapies(param)
            .then((response) => {
              if(response.data && response.data.length > 0){
                this.OptionTherapies = response.data;

				if(this.OptionTherapies.length === 1){
					this.TherapiesVModel = this.OptionTherapies[0].code;					
				}
				this.getNoteTypes();
              }             
            })
            .catch((error) => {             
             this.showResponseErrorMessage(error);
            });
		}
 
    },
	AdjustNoteContainer(Operation){
		var CountNotes = 0;		
		CountNotes = Operation === 'ADD'?this.$refs.ContainerNotes.children.length+1:this.$refs.ContainerNotes.children.length-1;
		
			if(CountNotes === 1){
				this.ClassContainerNotes = 'cutescroll';
			}

			if(CountNotes > 1){
				this.ClassContainerNotes = 'notesHolder cutescroll';
			}
	},

	Accordion1Click(){
		this.ShowFilter = !this.ShowFilter;
		this.ShowNote = !this.ShowNote;	
	},

	ClickBtnAccordion2(){
		this.ShowFilter = !this.ShowFilter;
		this.ShowNote = !this.ShowNote;	
	},

	onResultados(obj) {
		this.$emit('load', true);		
		obj.DateFrom = this.RegistrationInfo.dateFrom ? moment(this.RegistrationInfo.dateFrom, Utils.getShortDateFormat()).format(): null;
		this.ExistsNote = this.ClinicalNotesListOpened.some(nItem => ( ((nItem.notesId === obj.notesId) && (nItem.Id === obj.Id)) ||
																		(((nItem.frequency != 'DAILY MULTIPLES') && (nItem.notesId === obj.notesId) && (nItem.transDate === obj.transDate)) ||
																		((nItem.frequency === 'DAILY MULTIPLES') && (nItem.notesId === obj.notesId) && (nItem.transDate === obj.transDate) && (nItem.noteTime === obj.noteTime)))));																	  
		
		if (!this.ExistsNote) {
			this.AdjustNoteContainer("ADD");
			this.ClinicalNotesListOpened.push(obj);
		}
		
		this.ClassAccordion2 = 'show';
        this.ShowNote = true;
		this.ShowFilter = false;
		// a short time for loading wheel
		setTimeout(() => this.$emit('load', false), 500);
	},
	CloseNote(index){		
		this.ClinicalNotesListOpened.splice(index, 1)
		this.AdjustNoteContainer("REMOVE");
		if(this.ClinicalNotesListOpened.length == 0){
			this.ShowFilter = true;
			this.ShowNote = false;
		}
	},
	selectRow(row) {
		row.toggleDetails();
	},

	ShowDetail(row) {
		row.toggleDetails();
	},
	GenerateDefaultDate() {
		let dd = new Date();
		this.DateNow = dd.setMinutes(
			dd.getMinutes() + dd.getTimezoneOffset()
		);
		this.$emit('load', false);
	},

	pageChanged(page) {            
      this.currentPage = page;
		this.parameter.PageNumber = this.currentPage;        
      this.getNoteList();
    },
	pageChangedSubItems(e) {            
      this.currentPageSubItems = e.page;	
      this.getNoteAllDate(e.NoteId,this.currentPageSubItems,this.perPageSubItems);
    },


    PerPageFunction(perpage){
      this.perPage = perpage;
		this.parameter.PageNumber = 1;
      this.getNoteList();
    },
	PerPageFunctionSubItems(e){
		this.perPageSubItems = e.page;     
		this.getNoteAllDate(e.NoteId,1,this.perPageSubItems);		
    },
	onRowSelected(items) {
      this.selected = items
    },

    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },

    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },

    selectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.selectRow(2)
    },
	unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2)
    },

	ChangeDropDownTherapies(value){
            this.TherapiesVModel = value ? value.code : '';
			this.getNoteTypes();
        },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

	onCheck(param){		
	//	alert(param);
		this.NotesId = param.notesId;
		this.currentPageSubItems = param.currentPage;
		this.perPageSubItems = 5;
		this.getNoteAllDate(this.NotesId,this.currentPageSubItems,this.perPageSubItems);
	},

	NoteIsDailyMultiple(NoteId){
		var result = false;
		this.items.forEach(element => {
			if(element.notesId === NoteId){	
				result = element.frequency.toLowerCase() === 'DAILY MULTIPLES'.toLowerCase();		
			}
        });
		return result;
	},

	ExistDate(arr,TransDate){
		for(var i = 0; i < arr.length; i++){
			if(arr[i].date === TransDate){
				return true;
			}
		}
		return false;
		//return arr.some(i => ((i.date === TransDate)));
	},

	async getDefaultDateFromAndDateTo(){		
		await ClinicalService.getPatientRegistrationsDefaultDates(this.$route.params.recordid)
            .then((response) => {
              if(response.data){
                let defaultDate = response.data;
				this.DateFrom = moment(defaultDate.dateFrom).format('YYYY-MM-DD');
				this.DateTo = moment(defaultDate.dateTo).format('YYYY-MM-DD');				
              }             
            })
            .catch((error) => {
              /*if (error.response) {
               this.showMessage(this.$tc('Msg.Error'),error,"error");
              }*/
             this.showResponseErrorMessage(error);
            });
	},

	getTimesByDate(arr,date){
		var temparr = [];
		var contextValue = null;
		for(var k = 0; k < arr.length; k++){
			if(arr[k].aiAssistContext){ contextValue = arr[k].aiAssistContext; break; }
		}
		for(var i = 0; i < arr.length; i++){
			if(moment(arr[i].transDate).format("ddd, ll") === date){
				//if(arr[i].noteTime){					
					var obj = {};					
					if(arr[i].noteStatus == 'New'){								
								obj.icon = 'ikon med-doc-new mr-2';
								obj.description = this.$t('Shared.IconDescN');				
							}
							else if(arr[i].noteStatus == 'Voided'){
								obj.icon = 'ikon med-doc-cancelled mr-2';
								obj.description = this.$t('Shared.IconDescVN');
							}
							else if(arr[i].noteStatus == 'Pending Signature'){
								obj.icon = 'ikon med-doc-pen-sup-signature  mr-2';
								obj.description = this.$t('Shared.IconDescPS');
							}
							else if(arr[i].noteStatus == 'Pending Cosigner Signature'){
								obj.icon = 'ikon med-doc-pen-sup-signature mr-2';
								obj.description = this.$t('Shared.IconDescPCS');
							}else{
								obj.icon = 'ikon med-doc-signed mr-2';
								obj.description = this.$t('Shared.IconDescF');
							}
							obj.Id = arr[i].headerID;
							obj.Time = moment(arr[i].noteTime).format("HH:mm:ss");
							obj.patientCode = this.NoteDates[i].patientCode;	
							obj.isBillable = this.NoteDates[i].isBillable;
							obj.isVoid = this.NoteDates[i].isVoid;
							obj.therapistName = this.NoteDates[i].therapistName;
							obj.coTherapistName = this.NoteDates[i].coTherapistName;
							obj.chartno = this.NoteDates[i].chartno;
							obj.defaultUnit = this.NoteDates[i].defaultUnit;
							obj.patientCode = this.NoteDates[i].patientCode;
							obj.coTherapistCode = this.NoteDates[i].coTherapistCode;
							obj.disableBillable = this.NoteDates[i].disableBillable;
							obj.showBilling = this.NoteDates[i].showBilling;
							obj.showReport = this.NoteDates[i].showReport;
							obj.voidedByName = this.NoteDates[i].voidedByName;
							obj.voidedDate = this.NoteDates[i].voidedDate;
							obj.frequency = this.NoteDates[i].frequency;
							obj.enableEdit = this.NoteDates[i].enableEdit;
							obj.userHasReadOnlyAccess = this.NoteDates[i].userHasReadOnlyAccess;
							obj.customFrame = this.NoteDates[i].customFrame;
							obj.admissionRecordId = this.NoteDates[i].admissionRecordId;
							obj.allowCosignNotesDoneByCosigners = this.NoteDates[i].allowCosignNotesDoneByCosigners;
							if(this.NoteDates[i].coSignedDate){
								obj.coSignedDate = Utils.formatterDateTimeToString(this.NoteDates[i].coSignedDate);
								//obj.coSignedDate = moment(this.NoteDates[i].coSignedDate).format("ddd, ll");
							}else{
								obj.coSignedDate = null;
							}
							
							obj.endTime = this.NoteDates[i].endTime;
							obj.facilityCode = this.NoteDates[i].facilityCode;
							obj.isCoSigned = this.NoteDates[i].isCoSigned;
							obj.isPendingCoSignature = this.NoteDates[i].isPendingCoSignature;
							obj.isPendingSignature = this.NoteDates[i].isPendingSignature;
							obj.isSigned = this.NoteDates[i].isSigned;
							obj.noteStatus = this.NoteDates[i].noteStatus;
							obj.noteTime = this.NoteDates[i].noteTime;
							//obj.therapyCode = 
							if(this.NoteDates[i].serviceDate){
								obj.serviceDate = Utils.formatterDate(this.NoteDates[i].serviceDate);
							}else{
								obj.serviceDate = null;
							}
							if(this.NoteDates[i].signedDate){
								obj.signedDate = Utils.formatterDateTimeToString(this.NoteDates[i].signedDate);
								//obj.signedDate = moment(this.NoteDates[i].signedDate).format("ddd, ll");
							}else{
								obj.signedDate = null;
							}

							if(this.NoteDates[i].noteTime === null)
								obj.isBase = true;
							
							//obj.signedDate = this.NoteDates[i].signedDate;
							obj.startTime = this.NoteDates[i].startTime;
							obj.therapistCode = this.NoteDates[i].therapistCode;
							obj.transCode = this.NoteDates[i].transCode;
							obj.transDate = this.NoteDates[i].transDate;
							obj.notesContents = this.NoteDates[i].notesContents;
							obj.aiAssistContext = this.NoteDates[i].aiAssistContext || contextValue;
					temparr.push(obj);
				//}
				
			}
		}
		return temparr;
	},

	async getNoteAllDate(notesid,currentPageSubItems,perPageSubItems){
		this.$emit('load', true);
		this.parameter.PageNumber = currentPageSubItems;           
        this.parameter.PageSize = perPageSubItems;
		this.parameter.PatientCode = this.$route.params.id;
		this.parameter.DateFrom = this.DateFrom;
		this.parameter.DateTo = this.DateTo;
		this.parameter.RecordId = this.$route.params.recordid;
		this.parameter.TransCode = this.TherapiesVModel;		
		this.parameter.NoteStatus = this.NoteStatusVModel.value;		
		this.parameter.NotesId = notesid;

		var SubItems = [];
		var Exist = false;

      await ClinicalService.getAllDate(this.parameter)
                .then((response) => {
                     if(response.status == '200' && response.data){
                        this.NoteDates = response.data;	
						var l = this.NoteDates.length;
						let headerString = response.headers["x-pagination"];
						this.Header = JSON.parse(headerString);
						var totalRowsSubItems = this.Header.TotalCount;					
						var Pagination = {};				
						var obj = {};
					
						Pagination.currentPageSubItems = currentPageSubItems;
						Pagination.perPageSubItems = perPageSubItems;
						Pagination.totalRowsSubItems = totalRowsSubItems;
						if(l > 0){
							if(this.NoteIsDailyMultiple(notesid)){
								for(var i = 0; i<l; i++){
							
									var TransD = moment(this.NoteDates[i].transDate).format("ddd, ll");
									Exist = this.ExistDate(SubItems,TransD);
									obj.ArrTimes = this.getTimesByDate(this.NoteDates, TransD);
									obj.allowCosignNotesDoneByCosigners = this.NoteDates[i].allowCosignNotesDoneByCosigners;
									obj.date = TransD;
									obj.dateFormatted = Utils.formatterDateToShortLocaleString(this.NoteDates[i].transDate);
									obj.aiAssistContext = obj.ArrTimes.length > 0 ? obj.ArrTimes[0].aiAssistContext : null;

									if(!Exist)
										SubItems.push(obj);

									obj = {};
								}
							}else{
								for(var j = 0; j<l; j++){
							obj = {
								admissionRecordId:"",
								patientCode:'',
								date:'',
								therapistName:"",
								coTherapistName:"",
								icon:'',
								allowCosignNotesDoneByCosigners:false,
								description:'',
								Id:'',
								isBillable:false,
								defaultUnit:0,
								isVoid:false,
								coTherapistCode:null,
								coSignedDate:null,
								frequency:"",
								endTime:null,
								facilityCode:"",
								isCoSigned:null,
								isPendingCoSignature:null,
								isPendingSignature:null,
								isSigned:null,
								noteStatus:"",
								noteTime:null,							
								chartno:"",
								serviceDate:null,
								signedDate:null,
								startTime:null,
								therapistCode:"",
								transCode:"",
								transDate:null,
								notesContents:"",
								disableBillable:false,
								showReport:false,
								showBilling:false,
								userHasReadOnlyAccess:false,
								enableEdit:true,
								customFrame:"",
								isDCS: false,
								voidedByName:"",
								voidedDate:null
							};

							obj.admissionRecordId = this.NoteDates[j].admissionRecordId;
							obj.patientCode = this.NoteDates[j].patientCode;
							obj.therapistName = this.NoteDates[j].therapistName;
							obj.coTherapistName = this.NoteDates[j].coTherapistName;
							obj.date = moment(this.NoteDates[j].transDate).format("ddd, ll");
							obj.dateFormatted = Utils.formatterDateToShortLocaleString(this.NoteDates[j].transDate);
							obj.Id = this.NoteDates[j].headerID;
							obj.allowCosignNotesDoneByCosigners = this.NoteDates[j].allowCosignNotesDoneByCosigners;
							obj.isBillable = this.NoteDates[j].isBillable;
							obj.isVoid = this.NoteDates[j].isVoid;
							obj.coTherapistCode = this.NoteDates[j].coTherapistCode;
							obj.disableBillable = this.NoteDates[j].disableBillable;
							obj.defaultUnit = this.NoteDates[j].defaultUnit;
							obj.showBilling = this.NoteDates[j].showBilling;
						
							obj.chartno = this.NoteDates[j].chartno;
							obj.frequency = this.NoteDates[j].frequency;
							obj.voidedByName = this.NoteDates[j].voidedByName;
							obj.voidedDate = this.NoteDates[j].voidedDate;
							obj.enableEdit = this.NoteDates[j].enableEdit;
							obj.customFrame = this.NoteDates[j].customFrame;
							obj.showReport = this.NoteDates[j].showReport;
							obj.userHasReadOnlyAccess = this.NoteDates[j].userHasReadOnlyAccess;	
							obj.isDCS = this.NoteDates[j].isDCS						
							if(this.NoteDates[j].coSignedDate){
								//obj.coSignedDate = Utils.formatterDateTimeToString(this.NoteDates[j].coSignedDate);
								obj.coSignedDate = moment(this.NoteDates[j].coSignedDate).format("ddd, ll");
							}
							obj.endTime = this.NoteDates[j].endTime;
							obj.facilityCode = this.NoteDates[j].facilityCode;
							obj.isCoSigned = this.NoteDates[j].isCoSigned;
							obj.isPendingCoSignature = this.NoteDates[j].isPendingCoSignature;
							obj.isPendingSignature = this.NoteDates[j].isPendingSignature;
							obj.isSigned = this.NoteDates[j].isSigned;
							obj.noteStatus = this.NoteDates[j].noteStatus;
							obj.noteTime = this.NoteDates[j].noteTime;
							if(this.NoteDates[j].serviceDate){
								obj.serviceDate = Utils.formatterDate(this.NoteDates[j].serviceDate);
							}
							if(this.NoteDates[j].signedDate){
								//obj.signedDate = Utils.formatterDateTimeToString(this.NoteDates[j].signedDate);
								obj.signedDate = moment(this.NoteDates[j].signedDate).format("ddd, ll");
							}							
							
							obj.startTime = this.NoteDates[j].startTime;
							obj.therapistCode = this.NoteDates[j].therapistCode;
							obj.transCode = this.NoteDates[j].transCode;
							obj.transDate = this.NoteDates[j].transDate;
							obj.notesContents = this.NoteDates[j].notesContents;
							if(this.NoteDates[j].noteStatus == 'New'){								
								obj.icon = 'ikon med-doc-new mr-2';
								obj.description = this.$t('Shared.IconDescN');				
							}
							else if(this.NoteDates[j].noteStatus == 'Voided'){
								obj.icon = 'ikon med-doc-cancelled mr-2';
								obj.description = this.$t('Shared.IconDescVN');
							}
							else if(this.NoteDates[j].noteStatus == 'Pending Signature'){
								obj.icon = 'ikon med-doc-pen-sup-signature mr-2';
								obj.description = this.$t('Shared.IconDescPS');
							}
							else if(this.NoteDates[j].noteStatus == 'Pending Cosigner Signature'){
								obj.icon = 'ikon med-doc-pen-sup-signature mr-2';
								obj.description = this.$t('Shared.IconDescPCS');
							}else{
								obj.icon = 'ikon med-doc-signed mr-2';
								obj.description = this.$t('Shared.IconDescF');
							}
							obj.aiAssistContext = this.NoteDates[j].aiAssistContext;
							SubItems.push(obj);
						}
							}

						}

						this.AddSubItemsbyRow(notesid,SubItems,Pagination);

                     }                     
                      this.$emit('load', false);
                })
                .catch((error) => {                    
                    this.$emit('load', false);
                    /*if (!error.response) {
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                      this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }*/
                   this.showResponseErrorMessage(error);
                }); 
     },

	getNoteList(){
		this.parameter.PageSize = this.perPage;
		this.parameter.PatientCode = this.$route.params.id;
		this.parameter.DateFrom = this.DateFrom;
		this.parameter.DateTo = this.DateTo;
		this.parameter.TransCode = this.TherapiesVModel;
		this.parameter.ProgramCode = this.ProgramCode;
		this.parameter.NoteStatus = this.NoteStatusVModel.value;
		this.parameter.UserId = LocalStorage.getUserId();

		if(this.DateFrom === ''){
			this.showMessage(this.$tc('Msg.Error'),this.$t('ClinicalNotes.DateFromRequired'),"error");
		}else if(this.DateTo === ''){
			this.showMessage(this.$tc('Msg.Error'),this.$t('ClinicalNotes.DateToRequired'),"error");
		}else{
			this.$emit('load', true);	
			ClinicalService.getNoteList(this.parameter)
                .then((response) => {
                     if(response.status == '200' && response.data){
                       this.items = response.data;
                       if(response.data.length > 0){                
                        let headerString = response.headers["x-pagination"];					
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;
                       }
                     }                     
						this.$emit('load', false);
						if (this.items.length === 0) {
							this.ShowMessageIsEmpty = true;
						}
                })
                .catch((error) => {                    
                    this.$emit('load', false);
                    /*if (!error.response) {
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                      this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }*/
                   this.showResponseErrorMessage(error);
                }); 
		}
  

     },

	AddSubItemsbyRow(NotesId,SubItems,Pagination){		
		this.items.forEach(element => {
			if(element.notesId === NotesId){				
				this.$set(element, 'currentPageSubItems', Pagination.currentPageSubItems);
				this.$set(element, 'perPageSubItems', Pagination.perPageSubItems);
				this.$set(element, 'totalRowsSubItems', Pagination.totalRowsSubItems);
				this.$set(element, 'SubItems', SubItems);
			}
        });		
	},

		SearchNotes() {			
			this.dateArr = [];
			this.items = [];
			this.totalRows = this.items.length;    
			this.currentPage = 1
		
            var DF = moment(this.DateFrom).format('YYYY/MM/DD');
			var DT = moment(this.DateTo).format('YYYY/MM/DD');
			var DateTo = "";
			var DD = null;
			var AD = moment(this.RegistrationInfo.dateFrom, Utils.getShortDateFormat()).format('YYYY/MM/DD');

			if(this.validate_required()){
				if(this.RegistrationInfo.dateTo){
					DD = moment(this.RegistrationInfo.dateTo, Utils.getShortDateFormat()).format('YYYY/MM/DD');
					DateTo = this.RegistrationInfo.dateTo;
				}

                if (!Utils.IsValidFieldDate(this.DateFrom) || !Utils.IsValidFieldDate(this.DateTo)) {
					this.showMessage(this.$tc('Msg.Error'), this.$tc('Msg.InvalidDate'),"error");				
				}
				else if(DF < AD){			
					this.showMessage(this.$tc('Msg.Error'),this.$t('ClinicalNotes.DateFromBefore', {DateFrom: Utils.formatterDateToString(this.DateFrom), AdmitDate: Utils.formatterDateToString(AD)}),"error");				
				}
				else if(this.RegistrationInfo.dateTo && DD !== null && DT > DD){				

					this.showMessage(this.$tc('Msg.Error'),this.$t('ClinicalNotes.DateToAfter', {DateTo1: Utils.formatterDateToString(this.DateTo), DateTo2: DateTo}),"error");			
				}else{
					this.parameter.PageNumber = this.currentPage;        
					this.getNoteList();
				}	
			}else{
				this.$emit('load', false);         
				this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");
			}
			
			
		},

		pendingChanges(){
			let notesEditing = 0
			this.ClinicalNotesListOpened.forEach(element => {				
				notesEditing = element.isEditing && !element.userHasReadOnlyAccess? notesEditing + 1 : notesEditing
			});
			return notesEditing > 0 ? true : false
		},

		beforeWindowUnload(e) {
			if (this.pendingChanges()) {
				e.preventDefault()
				e.returnValue = ''	
			}
		}
	},

	updated() {		
		if(this.ClinicalNotesListOpened.length > 1){
			this.ClinicalNotesListOpened.forEach(element => {
				let dom = document.getElementById("highlightInTitle_"+element.Id);
				dom.hidden = true;
			});
		}

		if(this.ClinicalNotesListOpened.length === 1){
			let dom = document.getElementById("highlightInTitle_"+this.ClinicalNotesListOpened[0].Id);
			dom.hidden = false;
		}
	},

	async created(){
        this.$emit('load', true);
		await this.getDefaultDateFromAndDateTo();
		this.EmployeeCode = this.$store.state.employeeCode;
		this.getProgramCodeByRecordId();
		this.getNoteOption();
		//this.getNotesTherapies();
		EventBus.$on("onNoteIsEditing", function (e) {     
			this.ClinicalNotesListOpened.map(function(note){
			if(note.Id == e.NoteId){
				note.isEditing = e.Status;
			}
            return note;
          });
		}.bind(this));
		window.addEventListener('beforeunload', this.beforeWindowUnload)
	},

	beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
	},



	mounted() {	
        moment.suppressDeprecationWarnings = true; 
		this.parameter.PageNumber = this.currentPage;
		this.getPatientInfo();
	//	this.getNoteTypes();		
		this.OptionsRightMenu.visible = true;
		this.OptionsRightMenu.btnvisible = true;
		this.OptionsRightMenu.itemdisabled = false;
		this.$emit('getVisibleMenu', this.OptionsRightMenu);
		this.$emit('getBtnRightMenu', this.OptionsRightMenu);
		this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems
		this.$emit('getVisibleMenu', this.OptionsRightMenu);
		this.GenerateDefaultDate();		
		
		EventBus.$on("ShowWeel", function (isShow) { 
			isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
	},

	destroyed(){
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false; 
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.$store.commit('setWrotePasswordNotes',false);
        this.$store.commit('setWrotePasswordCosignerNotes','');
		EventBus.$off('ShowWeel');
  }
};
</script>

<style src="@/assets/css/clinical/multiselect.css">
.showNote{
	display: auto !important;
}

@import "../../../assets/css/flex.css";
</style>

